<template>
  <div v-show="open" @click="handleWrapperClick" class="dialog-wrapper" ref="popup" :style="{'z-index': zIndex}">
    <div class="dialog">
      <div class="title">
        {{title}}
      </div>
      <div class="body">
        <div class="item" v-for="(item, i) in contents" :key="i" @click="clickItem(i)">{{item}}
        </div>
      </div>
      <div class="footer">
        <v-button secondary @click="cancel" class="left" :text='cancelText'></v-button>
      </div>
    </div>
  </div>
</template>

<script>
import Popup from './internal/popup'
import PopupManager from './internal/popup/manager'
export default {
  mixins: [Popup],
  props: {
    title: {
      type: String
    },
    contents: {
      type: Array
    },
    cancelText: {
      type: String,
      default: '取消'
    }
  },
  methods: {
    handleWrapperClick (e) {
      const wrapperEl = this.$refs.popup
      if (wrapperEl === e.target) PopupManager.handleOverlayClick()
    },
    cancel () {
      this.$emit('close')
      this.$emit('cancal')
    },
    clickItem (i) {
      this.$emit('close')
      this.$emit('ok', i)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../css/var.styl'
.dialog-wrapper
  position fixed
  left 0
  top 0
  right 0
  bottom 0
  display flex
  justify-content center
  align-items center

.dialog
  width 600px
  padding 0
  background-color #ffffff
  border-radius pt(20)
  depth(2)
  .title
    height pt(80)
    line-height pt(80)
    text-align center
    position relative
    font-size $normal-font-size
    color $normal-text-color
  .body
    overflow-x 'hidden'
    overflow-y 'auto'
    -webkit-overflow-scrolling 'touch'
    max-height 75%
    color $hightlint-text-color
    font-size $normal-font-size
    padding 0 0 pt(60) 0
    display flex
    flex-direction column
    justify-content space-around
    align-items center
    .item
      width 100%
      text-align center
      height pt(80)
      color $normal-text-color
      font-size $normal-font-size
      position relative
      line-height pt(80)
      border 0.5px solid $divide-line-color
  .footer
    height pt(120)
    padding 0 $normal-left-padding pt(40)
    display: flex;
    align-items: flex-start;
    justify-content space-between
    .left
      flex 1 1 auto
    .right
      flex 1 1 auto


.divide
  bottom 0
  position absolute
  divide()
</style>




// WEBPACK FOOTER //
// dialog-selector.vue?7e9e2b7c